/* istanbul ignore file */
export * from './form-components.module';
export * from './validation-icon/validation-icon.component';
